/**
 * Sayfa kaydırma göstergesi (fareyle kullanılan cihazlar). Tarayıcının çubuğu assets/pg-core.css ile gizlidir;
 * bu ince gösterge sayfanın üstünde durur, yer kaplamaz ve zemini yoktur. Kaydırırken ya da fare sağ kenara gelince
 * görünür, sonra söner. Sürüklenerek de sayfa kaydırılabilir. Klavye ve tekerlek tarayıcının kendi davranışıyla çalışır.
 */
(() => {
  if (window.__pgScrollbar) return;
  window.__pgScrollbar = true;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const root = document.documentElement;
  const bar = document.createElement('div');
  bar.className = 'pg-sb';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  const MIN_THUMB = 48;
  let hideTimer = null;
  let dragging = false;
  let dragOffset = 0;
  let thumb = MIN_THUMB;
  let queued = false;

  const range = () => root.scrollHeight - window.innerHeight;

  const layout = () => {
    queued = false;
    const vh = window.innerHeight;
    const max = range();
    if (max <= 1) {
      bar.style.display = 'none';
      return;
    }
    bar.style.display = '';
    thumb = Math.max(MIN_THUMB, (vh * vh) / root.scrollHeight);
    const top = (Math.min(window.scrollY, max) / max) * (vh - thumb);
    bar.style.height = `${thumb}px`;
    bar.style.transform = `translateY(${top}px)`;
  };

  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(layout);
  };

  const hideLater = () => {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      if (!dragging && !bar.matches(':hover')) bar.classList.remove('is-on');
    }, 900);
  };

  const show = () => {
    bar.classList.add('is-on');
    hideLater();
  };

  window.addEventListener('scroll', () => {
    queue();
    show();
  }, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('mousemove', (e) => {
    if (e.clientX >= root.clientWidth - 16) show();
  }, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(queue).observe(document.body);

  bar.addEventListener('pointerleave', hideLater);
  bar.addEventListener('pointerdown', (e) => {
    e.preventDefault();
    dragging = true;
    dragOffset = e.clientY - bar.getBoundingClientRect().top;
    bar.setPointerCapture(e.pointerId);
    bar.classList.add('is-on', 'is-drag');
  });
  bar.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    const span = window.innerHeight - thumb;
    const ratio = span > 0 ? (e.clientY - dragOffset) / span : 0;
    window.scrollTo({ top: Math.max(0, Math.min(1, ratio)) * range(), behavior: 'instant' });
  });
  const endDrag = () => {
    dragging = false;
    bar.classList.remove('is-drag');
    hideLater();
  };
  bar.addEventListener('pointerup', endDrag);
  bar.addEventListener('pointercancel', endDrag);

  layout();
})();
